export enum GraphQLUploadType {
  QT_IMPORT = 'qt-import',
  ATTACHMENT = 'query-attachment'
}

export const GRAPHQL_UPLOAD_TYPE_HEADER = 'x-upload-type';
